<template>
  <div class="flex flex-col items-center justify-center min-h-[60vh] gap-3 text-slate-400 dark:text-slate-500">
    <div class="flex items-center justify-center rounded-2xl bg-slate-100 dark:bg-slate-800 text-slate-400 dark:text-slate-500 mb-1" style="width:72px;height:72px">
      <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
        <path d="M9 16.75C9 16.75 9 19.25 12 19.25C15 19.25 15 16.75 15 16.75M17.25 10V12L19.25 16.25H4.75L6.75 12V10C6.75 7.1 9.1 4.75 12 4.75C14.9 4.75 17.25 7.1 17.25 10Z"
          stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    <h2 class="text-lg font-semibold text-slate-800 dark:text-slate-100 m-0">Activity</h2>
    <p class="text-sm m-0">Recent activity across your workspace will appear here</p>
  </div>
</template>
